import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function StopoverFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.81 3.61214L11.63 3.67214L10.68 3.70214L9.86 3.73214L9.02 3.75214L8.2 2.16214C8.08 1.92214 8.09 1.62214 8.25 1.40214C8.4 1.17214 8.66 1.04214 8.94 1.07214L10.94 1.25214C11.1 1.27214 11.26 1.33214 11.38 1.44214L13.81 3.61214Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.83 10.0421H19.82L15.51 10.1721L9.96 14.2621C9.83 14.3521 9.67 14.4021 9.51 14.4021H6.93C6.65 14.4021 6.39 14.2421 6.26 13.9821C6.13 13.7321 6.16 13.4221 6.33 13.2021L8.83 9.87214L5.42 9.44214C5.18 9.41214 4.96 9.26214 4.85 9.05214L2.73 5.11214C2.6 4.87214 2.61 4.59214 2.75 4.36214C2.89 4.13214 3.14 3.99214 3.4 4.00214L5.63 4.05214C5.84 4.05214 6.04 4.15214 6.18 4.31214L7.06 5.31214L8.47 5.27214L9.79 5.23214L10.62 5.21214L11.45 5.18214L13.26 5.13214L14.35 5.09214L16.51 5.03214L17.1 5.01214H17.13C18.14 5.06214 19.23 5.53214 19.91 6.17214H19.92L20.92 7.19214C21.94 8.23214 21.25 9.95214 19.83 10.0421Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 17.4321C10.48 17.4321 9.25 18.6621 9.25 20.1821C9.25 21.7021 10.48 22.9321 12 22.9321C13.52 22.9321 14.75 21.7021 14.75 20.1821C14.75 18.6621 13.51 17.4321 12 17.4321ZM12 21.4321C11.31 21.4321 10.75 20.8721 10.75 20.1821C10.75 19.4921 11.31 18.9321 12 18.9321C12.69 18.9321 13.25 19.4921 13.25 20.1821C13.25 20.8721 12.69 21.4321 12 21.4321Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.5 19.4321H5.7C5.28 19.4321 4.95 19.7721 4.95 20.1821C4.95 20.5921 5.28 20.9321 5.7 20.9321H7.5C7.91 20.9321 8.25 20.6021 8.25 20.1821C8.25 19.7621 7.91 19.4321 7.5 19.4321ZM3.3 19.4321H1.5C1.08 19.4321 0.75 19.7721 0.75 20.1821C0.75 20.5921 1.08 20.9321 1.5 20.9321H3.3C3.71 20.9321 4.05 20.6021 4.05 20.1821C4.05 19.7621 3.71 19.4321 3.3 19.4321Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.5 19.4321H20.7C20.28 19.4321 19.95 19.7721 19.95 20.1821C19.95 20.5921 20.28 20.9321 20.7 20.9321H22.5C22.91 20.9321 23.25 20.6021 23.25 20.1821C23.25 19.7621 22.91 19.4321 22.5 19.4321ZM18.3 19.4321H16.5C16.08 19.4321 15.75 19.7721 15.75 20.1821C15.75 20.5921 16.08 20.9321 16.5 20.9321H18.3C18.71 20.9321 19.05 20.6021 19.05 20.1821C19.05 19.7621 18.71 19.4321 18.3 19.4321Z"
				fill="currentColor"
			/>
		</svg>
	);
}

StopoverFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default StopoverFilledIcon;
